var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    'music-play-icon',
    _vm.isPlaying ? 'playing' : '',
    _vm.isMask ? 'mask-type' : 'default-type'
  ],on:{"click":_vm.onClickIcon}},[(!_vm.isPlaying)?_c('icon-font',{staticClass:"icon",attrs:{"type":"iconplay"}}):_c('icon-font',{staticClass:"icon",attrs:{"type":"iconpause"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }